import api from "./api";
import type { MenuData, MenuSearchResult } from "../types";

class MenuService {
  getByRestaurant(restaurantCode) {
    return api().get(`/Menu/restaurant/${restaurantCode}`);
  }

  search(query) {
    return api().get("/Menu/search", {
      params: { query },
    });
  }
}

export default new MenuService();
